import {Component, inject, Input, OnInit} from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {IGamePlayerInputData} from "../../../interfaces/player/IGamePlayerInputData";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {GridApi, GridReadyEvent} from "ag-grid-community";
import {IWinnerPayoutWithWithWinnerInfo} from "../../../interfaces/IWinnerPayoutWithWithWinnerInfo";
import {PlayerInfoTableDefs} from "../../player-game-info/player-info-table-defs";
import {PlayersService} from "../../../services/players.service";
import {SnackbarService} from "../../../services/snackbar.service";

@Component({
  selector: 'app-manage-player-winnings',
  standalone: true,
    imports: [
        AgGridAngular,
        MatProgressSpinner
    ],
  templateUrl: './manage-player-winnings.component.html',
  styleUrl: './manage-player-winnings.component.css'
})
export class ManagePlayerWinningsComponent implements OnInit {

  private playerColDefs = inject(PlayerInfoTableDefs);
  private playerService = inject(PlayersService);
  private snackBarService = inject(SnackbarService);

  @Input()
  public set gamePlayerData(gamePlayerDataP: IGamePlayerInputData) {
    if (gamePlayerDataP.playerId && gamePlayerDataP.game.Id) {
      this.game = gamePlayerDataP.game;
      this.playerId = gamePlayerDataP.playerId;
    }
  }

  public winnings: IWinnerPayoutWithWithWinnerInfo[] = [];
  public playerWinningsColDefs= this.playerColDefs.playerWinnerColDefs;
  public winningsApi!: GridApi<IWinnerPayoutWithWithWinnerInfo>;
  public uiState = UIStateEnum.ShowData;
  public uiStateForTemplate = UIStateEnum;
  public game: IGameQueryResult | null = null;
  public playerId: string = '';

  ngOnInit() {
    this.uiState = UIStateEnum.ShowLoading;
    this.playerService.getWinnerResultsForPlayerInGame(this.playerId, this.game?.Id!).subscribe({
      next: winResults => {
        this.winnings = winResults.Winnings;
        this.uiState = UIStateEnum.ShowData;
      },
      error: err => {
        this.uiState = UIStateEnum.ShowData;
        this.snackBarService.openErrorSnackBar("Failed to fetch player win results");
      }
    });
  }

  onPlayerWinningsGridReady(params: GridReadyEvent<IWinnerPayoutWithWithWinnerInfo>)
  {
    this.winningsApi = params.api;
    this.winningsApi.sizeColumnsToFit({
      defaultMinWidth: 60
    });
  }
}
